// New-room modal open/close helpers — registered via context.functions so
// any element can dispatch them with:
//   el.call('openNewRoomModal', initialDraft?)
//   el.call('closeNewRoomModal')
//
// Migrated 2026-06-01 from `root.update({ showNewRoom: true, newRoomDraft })`
// to a @symbo.ls/windows custom-template layer. `root.newRoomDraft` stays
// as the data carrier — the body's reactive reads on it are unchanged.

const NEW_ROOM_LAYER_ID = 'meet-new-room'

const _rootState = (el) =>
  el?.state?.root || el?.getRoot?.()?.state?.root || el?.getRoot?.()?.state || null

export function openNewRoomModal(initialDraft) {
  const root = _rootState(this)
  if (!root) return
  root.update({
    newRoomDraft: {
      name: '',
      kind: 'room',
      transcribeEnabled: true,
      isPrivate: false,
      ...(initialDraft || {})
    }
  })
  // MODAL-X-OVERFLOW-1: openCustomModal supplies a safe default maxHeight
  // so the Close X can't be pushed off-screen by tall content / a short
  // viewport (see workspace/packages/shared/functions/openCustomModal.js).
  this.call('openCustomModal', {
    id: NEW_ROOM_LAYER_ID,
    content: { extends: 'MeetNewRoomModal' }
  })
}

export function closeNewRoomModal() {
  const root = _rootState(this)
  root?.update({ newRoomDraft: null })
  this.call('closeModal', NEW_ROOM_LAYER_ID)
}

// The New call sheet's Who can join segments (AppSegmented `select` names this
// function; `this` is the segment the person picked). The rest of the draft
// stays; the chosen value again writes nothing.
export function meetSetNewRoomVisibility(visibility) {
  const root = _rootState(this)
  if (!root) return
  if (visibility !== 'private' && visibility !== 'workspace' && visibility !== 'public') return
  const draft = root.newRoomDraft || {}
  if (draft.visibility === visibility) return
  root.update({ newRoomDraft: { ...draft, visibility } })
}
